import Castilo61 from './Castilo 6.webp'
import Castilo62 from './Castilo 6.webp'





const Castilo6images =[
Castilo61,Castilo62
]

export default Castilo6images;